if (!customElements.get('h7-cart-plan-migration')) {
  class H7CartPlanMigration extends HTMLElement {
    connectedCallback() {
      if (this.isUpdating) return;
      this.isUpdating = true;
      this.updatePlan();
    }

    async updatePlan() {
      const line = Number(this.dataset.line);
      const quantity = Number(this.dataset.quantity);
      const sellingPlan = Number(this.dataset.sellingPlan);

      if (!line || !quantity || !sellingPlan) {
        this.showError();
        return;
      }

      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/change.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            line,
            quantity,
            selling_plan: sellingPlan,
          }),
        });

        if (!response.ok) throw new Error(`Cart plan update returned ${response.status}`);

        document.dispatchEvent(new CustomEvent('h7:cart-plan-migrated', {
          detail: { line, quantity, sellingPlan },
        }));

        if (this.dataset.reload !== 'false') window.location.reload();
      } catch (error) {
        this.showError();
      }
    }

    showError() {
      this.isUpdating = false;
      this.closest('.cart-item')?.removeAttribute('aria-busy');
      this.textContent = this.dataset.errorLabel || 'Refresh the page to update this subscription price.';
    }
  }

  customElements.define('h7-cart-plan-migration', H7CartPlanMigration);
}

const placeWalletButtonsInPreferredOrder = () => {
  const slotOrder = ['button-ShopPay', 'button-ApplePay', 'button-GooglePay'];
  const buttons = [
    document.querySelector('shopify-apple-pay-button'),
    document.querySelector('shopify-google-pay-button'),
    document.querySelector('shop-pay-wallet-button'),
  ].filter(Boolean);
  if (buttons.length < 2) return false;

  const availableSlots = buttons
    .map((button) => button.slot)
    .filter((slot) => slotOrder.includes(slot))
    .sort((a, b) => slotOrder.indexOf(a) - slotOrder.indexOf(b));
  if (availableSlots.length !== buttons.length) return false;

  buttons.forEach((button, index) => {
    button.slot = availableSlots[index];
  });
  return true;
};

placeWalletButtonsInPreferredOrder();
// The observer must stay alive because Shopify re-injects the wallet buttons
// whenever the cart footer re-renders, but the work is coalesced to one pass
// per frame so document-wide mutation bursts (cart repaints, review widget
// churn) stop triggering three queries per mutation record.
let walletPlacementScheduled = false;
const walletObserver = new MutationObserver(() => {
  if (walletPlacementScheduled) return;
  walletPlacementScheduled = true;
  requestAnimationFrame(() => {
    walletPlacementScheduled = false;
    placeWalletButtonsInPreferredOrder();
  });
});
walletObserver.observe(document.documentElement, { childList: true, subtree: true });
